// import React, { useCallback, useState } from "react";
// import styles from "./styles.module.scss";
// import CommonFilter from "../../../../atoms/CommonFilter";
// import DateRangePickerShortCuts from "../../../../organisms/dateRangePicker";
// import {
//   addHours,
//   startOfDay,

//   subDays
// } from "rsuite/esm/internals/utils/date";
// import TimeReportChart from "./TimeReportChart";
// import {
//   getEmployeeList,
//   getAllProjects,
//   getTeamsList,
// } from "../../../../../services/basicGets";
// import { useEffect } from "react";
// import { useCookies } from "react-cookie";
// import { getData } from "../../../../../services";
// import { useSelector } from "react-redux";

// const GraphContainer = ({date, filters , id}) => {
//   const [cookies] = useCookies(["e_t"]);
//   const defaultToday = new Date();
 
//   const [tableData, setTableData]= useState([]);

//   const accessData = useSelector((state) => state.accessDetails?.accessData);
//   const isAdmin = accessData?.role?.label === "Admin";





//   const getDashboardGraphData = useCallback(async () => {
//     try {
//       const res = await getData({
//         endpoint: "Dashboard/getTaskTimerDashboardGraph",
//         params: {
//           // search_query: searchedValue,
//           // page: currentPage,
//           // page_limit: itemsPerPage,
//           // business_id: cookies.bid,
//           start_date: date?.start_date,
//           end_date : date?.end_date,
//           project_ids: JSON.stringify(filters?.project),
//           employee_ids : JSON.stringify(filters?.employee),
//           team_ids : JSON.stringify(filters?.team),
//           employee_id: isAdmin ? null : cookies.euid,

//         },

//         token: cookies.e_t,
//       });
//       if (res) {
//         setTableData(res);
//       }
//     } catch (error) {
//       console.error(error); // Use console.error for errors
//     }
//   }, [cookies.e_t, date, filters]);

//   useEffect(() => {
//     getDashboardGraphData();
//   }, [getDashboardGraphData]);




//   return (
//     <div className={styles.graph_container} id={id}>




//       <TimeReportChart categorydata={tableData?.category} data={tableData?.chart_data?.[0]?.data} />
//     </div>
//   );
// };

// export default GraphContainer;

import React, { useCallback, useState, useEffect } from "react";
import styles from "./styles.module.scss";
import CommonFilter from "../../../../atoms/CommonFilter";
import DateRangePickerShortCuts from "../../../../organisms/dateRangePicker";
import { addHours, startOfDay, subDays } from "rsuite/esm/internals/utils/date";
import TimeReportChart from "./TimeReportChart";
import {
  getEmployeeList,
  getAllProjects,
  getTeamsList,
} from "../../../../../services/basicGets";
import { useCookies } from "react-cookie";
import { getData } from "../../../../../services";
import { useSelector } from "react-redux";

const GraphContainer = ({ date, filters, id, onDataLoad }) => {
  const [cookies] = useCookies(["e_t"]);
  const [tableData, setTableData] = useState([]);
  const accessData = useSelector((state) => state.accessDetails?.accessData);
  const isAdmin = accessData?.role?.label === "Admin";

  const getDashboardGraphData = useCallback(async () => {
    try {
      const res = await getData({
        endpoint: "Dashboard/getTaskTimerDashboardGraph",
        params: {
          start_date: date?.start_date,
          end_date: date?.end_date,
          project_ids: JSON.stringify(filters?.project),
          employee_ids: JSON.stringify(filters?.employee),
          team_ids: JSON.stringify(filters?.team),
          employee_id: isAdmin ? null : cookies.euid,
          client_ids: JSON.stringify(filters?.client),
          businessSegment : JSON.stringify(filters?.business_segment),
        },
        token: cookies.e_t,
      });
      
      if (res) {
        setTableData(res);
        // Pass data to parent component if callback exists
        if (onDataLoad) {
          // Transform data for table usage
          const tableData = res.category.map((date, index) => ({
            date: date,
            // project: res.chart_data[0]?.name || "Time Tracking",
            value: res.chart_data[0]?.data[index] || 0
          }));
          onDataLoad(tableData || []);
        }
      }
    } catch (error) {
      console.error(error);
    }
  }, [cookies.e_t, date, filters, onDataLoad, isAdmin, cookies.euid]);

  useEffect(() => {
    getDashboardGraphData();
  }, [getDashboardGraphData]);

  return (
    <div className={styles.graph_container} id={id}>
      <TimeReportChart 
        categorydata={tableData?.category} 
        data={tableData?.chart_data?.[0]?.data} 
      />
    </div>
  );
};

export default GraphContainer;
